import { Route } from "found";
import DocumentTitle from "react-document-title";
import { useTranslation } from "react-i18next";

import TemplateManagementPage from "./TemplateManagementPage";
import TemplateManagementPageQuery from "./TemplateManagementPageQuery";

import { ErrorCheckWrapper } from "pstat-anywhere/utils/routes";
import { withLabelContext } from "pstat-anywhere/context_providers/LabelContext";
import { ContentContainer } from "pstat-anywhere/components/pages";

function ContainerWrapper(props) {
  return <ContentContainer>{props.children}</ContentContainer>;
}

const ReportDocumentTitleWrapper = withLabelContext(
  ({ labels, titleKey, Component, ...props }) => {
    console.log(labels);
    const { t } = useTranslation();
    return (
      <DocumentTitle title={t(titleKey, labels)}>
        <Component {...props} />
      </DocumentTitle>
    );
  }
);

const getReportParams = location => ({
  sort: location.query.sort,
  first: 20,
  after: location.query.after
});

const routes = (
  <Route path="system_templates" Component={ContainerWrapper}>
    <Route
      path=""
      data={{ routeName: "manage_templates" }}
      query={TemplateManagementPageQuery}
      prepareVariables={(params, { location }) => ({
        ...params,
        ...getReportParams(location)
      })}
      render={({ props }) => (
        <ErrorCheckWrapper queryName="systemDocumentTemplates" {...props}>
          <ReportDocumentTitleWrapper
            titleKey="systemDocumentTemplates.header"
            Component={TemplateManagementPage}
            {...props}
          />
        </ErrorCheckWrapper>
      )}
    />
  </Route>
);

export default routes;
